module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_7016.e8372483.png";